module.exports = __webpack_public_path__ + "static/media/icon.3914466f.png";